import axios, { AxiosResponse } from 'axios';
import {
    ApiServiceDictionaryItem,
    ApiTokenAccessItem,
    SaveApiTokenAccessRequest,
} from './types';

const requestConfig = {
    skipGlobalError: true,
};

export const getApiServiceDictionary = (): Promise<
    AxiosResponse<ApiServiceDictionaryItem[]>
> => {
    return axios.get('/services/isnaportal/api/admin/api-service-dictionary', {
        ...requestConfig,
        params: {
            onlyActive: true,
        },
    } as any);
};

export const getTokenApiAccess = (
    taxpayerCode: string,
    signal?: AbortSignal
): Promise<AxiosResponse<ApiTokenAccessItem[]>> => {
    return axios.get(`/services/isnaportal/api/admin/token/${taxpayerCode}/api-access`, {
        ...requestConfig,
        signal,
    } as any);
};

export const saveTokenApiAccess = (
    data: SaveApiTokenAccessRequest
): Promise<AxiosResponse<void>> => {
    return axios.post('/services/isnaportal/api/admin/token/api-access', data, {
        ...requestConfig,
    } as any);
};

export const getTokenApiAccessCsv = (
    taxpayerCode: string
): Promise<AxiosResponse<Blob>> => {
    return axios.get(
        `/services/isnaportal/api/admin/token/${taxpayerCode}/api-access/csv`,
        {
            ...requestConfig,
            responseType: 'blob',
        } as any
    );
};